const f = {
  id: "Cash4Life",
  name: "Cash4Life",
  style: {
    colorPrimary: "#196b53",
    extraBall: {
      bg: "#196b53",
      color: "#ffffff"
    }
  }
};
export {
  f as default
};
